﻿// Generique
import Page = require("./components/Page");
import DefaultEdit = require("./components/DefaultEdit");
import DefaultSearchBox = require("./components/DefaultSearchBox");
import DefaultSearchBoxExtension = require("./components/DefaultSearchBoxExtension");
import DefaultTransfertSearchBoxes = require("./components/DefaultTransfertSearchBoxes");
// Specifique
import DonneesReferentielles = require("./components/DonneesReferentielles");
import SecuriteUtilisateurEdit = require("./components/SecuriteUtilisateurEdit");
import AssocierDesMunicipalitesAuSyndicatSpecialise = require("./components/AssocierDesMunicipalitesAuSyndicatSpecialise");
import PanneauAdministration = require("./components/PanneauAdministration");
import SommaireTacheAdministrative = require("./components/SommaireTacheAdministrative");
import FermeAdditionSommaireActions = require("./components/FermeAdditionSommaireActions");
import FermeAdditionSommaireIdentification = require("./components/FermeAdditionSommaireIdentification");
import FermeAdditionSommaireMapaq = require("./components/FermeAdditionSommaireMapaq");
import GestionPersonneFerme = require("./components/GestionPersonneFerme");
import SommairePersonnes = require("./components/SommairePersonnes");
import SommairePersonne = require("./components/SommairePersonne");
import FduGenererLiens = require("./components/FduGenererLiens");
import FermeSommaireFluxDeTravaux = require("./components/FermeSommaireFluxDeTravaux");
import DefaultWorkflowStep = require("./components/DefaultWorkflowStep");
import DefaultNotes = require("./components/DefaultNotes");

export = {
    //== Generic components
    Page,
    DefaultEdit,
    DefaultSearchBox,
    DefaultSearchBoxExtension,
    DefaultTransfertSearchBoxes,
    DefaultNotes,
    //== Custom components
    DonneesReferentielles,
    SecuriteUtilisateurEdit,
    AssocierDesMunicipalitesAuSyndicatSpecialise,
    PanneauAdministration,
    SommaireTacheAdministrative,
    FermeSommaireFluxDeTravaux,
    DefaultWorkflowStep,
    FermeAdditionSommaireActions,
    FermeAdditionSommaireIdentification,
    FermeAdditionSommaireMapaq,
    SommairePersonnes,
    SommairePersonne,
    GestionPersonneFerme,
    FduGenererLiens
};
